__turbopack_context__.v({
  "container": "_7bEU0a_container",
  "input": "_7bEU0a_input",
  "placeholder": "_7bEU0a_placeholder",
  "submit": "_7bEU0a_submit",
});
